import axios from 'axios';

const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api/v1'
  : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api/v1');

// withCredentials: true propositalmente — se quem está navegando for o
// admin logado (mesmo cookie do painel), a definição de uma enquete em
// rascunho/privada é liberada para preview. Para o visitante comum, que não
// tem esse cookie, não muda nada.
const api = axios.create({
  baseURL: `${API_BASE_URL}/enquetes`,
  timeout: 30000,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      switch (status) {
        case 404:
          error.userMessage = 'Enquete não encontrada.';
          break;
        case 400:
          error.userMessage = data?.error || 'Dados inválidos enviados';
          break;
        case 403:
          error.userMessage = data?.error || 'Enquete não está aberta para votação';
          break;
        case 409:
          error.userMessage = data?.error || 'Voto já registrado';
          break;
        case 429:
          error.userMessage = 'Muitas tentativas. Aguarde alguns minutos.';
          break;
        default:
          error.userMessage = data?.error || 'Erro interno do servidor. Tente novamente.';
      }
    } else if (error.request) {
      error.userMessage = 'Erro de conexão. Verifique sua internet.';
    } else {
      error.userMessage = 'Erro interno da aplicação';
    }
    return Promise.reject(error);
  }
);

export const enqueteDinamicaAPI = {
  async listarPublicas() {
    const response = await api.get('/');
    return response.data;
  },

  async obterDefinicao(slug) {
    const response = await api.get(`/${slug}`);
    return response.data;
  },

  async gerarToken(slug) {
    const response = await api.get(`/${slug}/token`);
    return response.data;
  },

  async registrarVoto(slug, dadosVoto) {
    const response = await api.post(`/${slug}/votar`, dadosVoto);
    return response.data;
  },

  async obterEstatisticas(slug) {
    const response = await api.get(`/${slug}/estatisticas`);
    return response.data;
  }
};

// Storage por enquete (localStorage), parametrizado por slug — cada enquete
// dinâmica tem sua própria chave, sem colidir entre si nem com o Portal/
// Telão Brasil (que usam suas próprias chaves fixas em utils/api.js e
// utils/telaBrasilAPI.js, não tocadas aqui).
export function criarStorageDinamico(slug) {
  const chaveToken = `enquete_${slug}_tracking_token`;
  const chaveVotado = `enquete_${slug}_voted`;

  return {
    saveTrackingToken(token) {
      try {
        const data = { token, expiresAt: Date.now() + 24 * 60 * 60 * 1000 };
        localStorage.setItem(chaveToken, JSON.stringify(data));
      } catch (error) {
        console.error('Erro ao salvar token:', error);
      }
    },

    getTrackingToken() {
      try {
        const stored = localStorage.getItem(chaveToken);
        if (!stored) return null;
        const data = JSON.parse(stored);
        if (Date.now() > data.expiresAt) {
          localStorage.removeItem(chaveToken);
          return null;
        }
        return data.token;
      } catch (error) {
        localStorage.removeItem(chaveToken);
        return null;
      }
    },

    clearTrackingToken() {
      localStorage.removeItem(chaveToken);
    },

    hasVoted() {
      return localStorage.getItem(chaveVotado) === 'true';
    },

    markAsVoted() {
      localStorage.setItem(chaveVotado, 'true');
    }
  };
}

export default enqueteDinamicaAPI;
